import { useState } from 'react'
import SelectPlace from '../Components/SelectPlace'
import Place from '../Definitions/Place';
import Route from '../Definitions/Route';
import NumSelect from '../Components/NumSelect';

const EditTrip = (props: {
	cbSave: (nr: number, route: Route) => void;
	cbDelete?: (nr: number) => void;
	cbCancel?: () => void;
	routes: Route[];
	reverse: boolean;
	route?: Route;
	id: number;
}) => {
	const { cbSave, cbDelete, cbCancel, id, route, routes, reverse } = props;
	let rs = route?.start;
	let re = route?.end;
	if (reverse) {
		let tmp = re;
		re = rs;
		rs = tmp;
		console.log("reverse", rs, re);
	}
	const [placeStart, setPlaceStart] = useState<Place>(rs ?? { id: "", name: "" });
	const [placeEnd, setPlaceEnd] = useState<Place>(re ?? { id: "", name: "" });
	const [color] = useState(route?.color ?? "#000");
	const [numResult, setNumResult] = useState(route?.numResult ?? "5");

	const cbSetPlaceStart = (id: string, name: string) => {
		setPlaceStart({ id: id, name: name })
	}
	const cbSetPlaceEnd = (id: string, name: string) => {
		setPlaceEnd({ id: id, name: name })
	}
	const switchRoutes = () => {
		let s = placeStart;
		let e = placeEnd;
		setPlaceStart({ ...e });
		setPlaceEnd({ ...s });
	}
	const submit = () => {
		let route = {
			start: placeStart,
			end: placeEnd,
			color: color,
			numResult: numResult,
			useCoords: placeStart.id === "here" || placeEnd.id === "here"
		}
		if (reverse) {
			route.start = placeEnd;
			route.end = placeStart;
		}
		cbSave(id, route);
	}

	let tmp: Place[] = [];
	routes.map((item) => { tmp.push(item.start); tmp.push(item.end); return undefined })
	let places: Place[] = tmp.filter((p, idx, arr) => {
		for (let i = idx + 1; i < arr.length; i++) {
			if (arr[i].id === p.id)
				return false;

		}
		return true;
	});

	return (
		<table>
			<tbody>
				<tr>
					<td>
						{cbCancel ?
							<span onClick={cbCancel}>
								⨂
							</span>
							:
							<></>

						}
					</td>
					<td style={{ backgroundColor: color }}>
						{route ?
							<></>
							:
							<h2>Lägg till en resväg</h2>
						}
						<SelectPlace
							key={"start" + placeStart.name}
							label={"Från"}
							defaultValue={placeStart.name}
							callback={cbSetPlaceStart}
							placeholder={"namn på hållplats"}
							places={places} />
						<br />
						<button onClick={switchRoutes}>
							↓↑
						</button>
						<br />
						<SelectPlace
							key={"end" + placeStart.name}
							label={"Till"}
							defaultValue={placeEnd.name}
							callback={cbSetPlaceEnd}
							placeholder={"namn på hållplats"}
							places={places} />
						<br />
						<NumSelect label="Antal resultat" value={numResult} onChange={setNumResult} />
						<br />
						<div>
							{cbCancel ?
								<button
									className='actionbutton'
									onClick={cbCancel}>
									⨂ Avbryt
								</button>
								:
								<></>
							}
							{cbDelete ?
								<button
									className='actionbutton'
									onClick={() => {
										if (window.confirm("Är du säker på att radera?"))
											cbDelete(id)
									}}>
									🗑 Radera
								</button>
								:
								<></>
							}
							<button
								onClick={submit}
								className='actionbutton'
								disabled={placeStart.id === "" || placeEnd.id === ""}
							>
								💾 Spara
							</button>
						</div>
					</td>
				</tr>
			</tbody>
		</table >
	)
}

export default EditTrip